/* Maison Dolce - confirmation d'ajout au panier avec action.
   Intercepte /cart/add.js : aucune modification des autres scripts du theme. */
(function () {
  "use strict";

  var box = null, timer = null;
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function money(c) {
    return (Number(c) / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>\"]/g, function (m) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[m];
    });
  }
  function thumb(url) {
    if (!url) return "";
    return url.indexOf("?") === -1 ? url + "?width=160" : url + "&width=160";
  }

  function hide() {
    if (box) box.classList.remove("show");
    document.body.classList.remove("cc-open");
  }

  function show(item) {
    if (!item || !item.product_title) return;

    if (!box) {
      box = document.createElement("div");
      box.className = "cart-confirm";
      box.setAttribute("role", "status");
      box.setAttribute("aria-live", "polite");
      document.body.appendChild(box);
    }

    var variante = item.variant_title && item.variant_title !== "Default Title" ? esc(item.variant_title) : "";
    var prix = item.final_line_price != null ? item.final_line_price : (item.line_price != null ? item.line_price : item.price);
    var img = item.image || item.featured_image && item.featured_image.url;

    box.innerHTML =
      '<div class="cart-confirm__head">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6L9 17l-5-5"/></svg>' +
        "Ajouté au panier" +
        '<button class="cart-confirm__close" type="button" aria-label="Fermer">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        "</button>" +
      "</div>" +
      '<div class="cart-confirm__body">' +
        '<div class="cart-confirm__img">' + (img ? '<img src="' + esc(thumb(img)) + '" alt="" width="58" height="58">' : "") + "</div>" +
        '<div class="cart-confirm__meta">' +
          '<p class="cart-confirm__name">' + esc(item.product_title) + "</p>" +
          (variante ? '<p class="cart-confirm__var">' + variante + "</p>" : "") +
          '<p class="cart-confirm__price">' + money(prix) + "</p>" +
        "</div>" +
      "</div>" +
      '<div class="cart-confirm__total"><span>Total du panier</span><b data-cc-total>—</b></div>' +
      '<div class="cart-confirm__actions">' +
        '<a class="cart-confirm__ghost" href="' + routes + 'cart">Voir le panier</a>' +
        '<a class="cart-confirm__primary" href="' + routes + 'checkout">Commander</a>' +
      "</div>";

    box.querySelector(".cart-confirm__close").addEventListener("click", hide);

    window.fetch(routes + "cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var t = box.querySelector("[data-cc-total]");
        if (t) t.textContent = money(cart.total_price);
      })
      .catch(function () {});

    document.body.classList.add("cc-open");
    requestAnimationFrame(function () { box.classList.add("show"); });
    clearTimeout(timer);
    timer = setTimeout(hide, 9000);
  }

  /* --- interception de /cart/add.js --- */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === "function") {
    window.fetch = function (input, init) {
      var url = "";
      try { url = typeof input === "string" ? input : (input && input.url) || ""; } catch (e) {}
      var isAdd = url.indexOf("/cart/add") !== -1;
      var res = nativeFetch.apply(this, arguments);
      if (!isAdd) return res;
      return res.then(function (r) {
        try {
          r.clone().json().then(function (d) {
            if (!d || d.status) return;
            show(d.items && d.items.length ? d.items[0] : d);
          }).catch(function () {});
        } catch (e) {}
        return r;
      });
    };
  }

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") hide(); });
})();
